import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy} from '@angular/core';
import {Widget} from "@ispm/widgets/decorator/widget.decorator";
import {IWidgetItem} from "@ispm/widgets/interfaces/widget-item.interface";
import {has} from 'lodash';

@Component({
  selector: 'ispm-checkbox-simple-group',
  templateUrl: './checkbox-simple-group.component.html',
  styleUrls: ['./checkbox-simple-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

@Widget('CheckboxSimpleGroup')
export class CheckboxSimpleGroupComponent implements OnDestroy, IWidgetItem<any> {

  widgetUpdateValueCallback: (value) => void;
  public widgetConfigPayload: any;
  public defaultList: boolean[] = [];
  public selectedItems: boolean[] = [];
  private data: string = '';

  constructor(private changeDetector: ChangeDetectorRef) {
  }

  set widgetConfig(widgetConfig) {
    this.widgetConfigPayload = widgetConfig.widgetPayload;
    if (has(this.widgetConfigPayload, 'defaultState')) {
      this.defaultList = this.widgetConfigPayload.defaultState;
      for (let i = 0; i < this.defaultList.length; i++) {
        this.selectedItems[i] = (this.selectedItems.length > i && this.selectedItems[i] != this.defaultList[i])
          ? this.selectedItems[i] : this.defaultList[i];
      }
      this.calculateFinalData();
    }
  }

  get widgetData() {
    return this.data;
  }

  set widgetData(data: any) {
    if (data === '') {
      this.selectedItems.fill(false);
      this.data = data;
      
    }
    else {
      if (typeof data === 'string') {
        const selectedData = data.split(',');
        if (selectedData.length > 0) {
          for (let inx = 0; inx < this.widgetConfigPayload.values.length; inx++) {
            const selected = selectedData.findIndex(selectedCode => this.widgetConfigPayload.values[inx].code === selectedCode) > -1;
            this.selectedItems[inx] = selected;
          }
        }
        this.calculateFinalData();
      }      
    }
    this.changeDetector.markForCheck();
  }

  public ngOnDestroy(): void {
    this.changeDetector.detach();
  }

  trackByFn(index, item: string) {
    return index;
  }

  onSelected(index) {
    this.calculateFinalData();
    this.widgetUpdateValueCallback(this.data);
  }

  private calculateFinalData() {
    let result = [];
    for (let i = 0; i < this.selectedItems.length; i++) {
      if (this.selectedItems[i])
        result.push(this.widgetConfigPayload.values[i].code);
    }
    this.data = result.join(',');
  }

}
